import { SodaGlobalParams } from '@/common/utils/request'
import { compareVersion } from '@/common/utils/util'
import storage from 'didi-store'
const semverGte = require('semver/functions/gte')

export function initGlobalBridge() {
  // console.log('soda:', window.Soda)

  window.SodaBD =
    window?.Soda?.manager ||
    window?.Fusion?.loadModule('Manager') ||
    window?.Fusion?.loadModule('SodaBD')
  // window.SodaBD = window.Soda
}

export function getSodaGlobalParams() {
  const Soda = window.Soda || {}
  return new Promise((resolve, reject) => {
    /* eslint-disable */
    if (!Soda.getGlobalParams) {
      let errInfo = {
        err: 'getGlobalParams undefined',
        ext: window.Soda,
      }
      reject(errInfo)
      return
    }
    Soda.getGlobalParams(function (extraData = {}) {
      // console.log('获取到extraData', extraData)
      let { errNo = 0, data = {} } = extraData
      if (errNo === 0) {
        return resolve(data)
      }
      let errInfo = {
        err: 'errNo != 0',
        ext: extraData,
      }
      return reject(errInfo)
    })
  })
}

/**
 * 是否显示titlebar
 * @param type 1: 显示 2: 隐藏
 */
export function toggleTitleBar(type) {
  if (window.Soda && window.Soda.toggleTitleBar && type) {
    window.Soda.toggleTitleBar(type)
  }
}
// 根据版本与设备进行判断，设置通栏高度
export async function getStatusBarInfo() {
  let statusBarInfo = {
    hasBar: true,
    barHeight: 0,
  }
  // 客户端打开
  if (window.Soda && window.Soda.getGlobalParams) {
    const { appVersion = '', platform = '' } = await SodaGlobalParams()
    let comVersionRes = -1
    // 存在通知栏的最高版本, 大于这些版本则没有端上的通知栏高度
    let existStausBarMaxVer = {
      ios: '1.2.4',
      android: '1.2.4',
    }
    comVersionRes = compareVersion(appVersion, existStausBarMaxVer[platform])
    // 端版本对比:没有通知栏
    if (String(comVersionRes) === '1' && window.Soda.getStatusBarHeight) {
      console.log('对比结果比通知栏版本大且能获取到状态栏高度')
      window.Soda.getStatusBarHeight(res => {
        const barHeight = res.data.height / window.devicePixelRatio
        statusBarInfo = {
          hasBar: false,
          barHeight: barHeight,
        }
        setStatusBarInfo(statusBarInfo, barHeight)
      })
    } else {
      // 有通知栏
      setStatusBarInfo(statusBarInfo, 0)
    }
  } else {
    // 浏览器中打开
    setStatusBarInfo(statusBarInfo, 0)
  }
}

function setStatusBarInfo(statusBarInfo, barHeight) {
  storage.set('StatusBarInfo', statusBarInfo) // 存储在storage中
  document.documentElement.style.setProperty('--barheight', `${barHeight}px`) // 设置全局css变量
}

export async function canOpenPageForNewWebview() {
  console.log('[log] canOpenPage111')
  const { appVersion = '0.0.0' } = await SodaGlobalParams()
  const canOpenPage = Soda.openPage && semverGte(appVersion, '1.3.2')
  console.log('[log] canOpenPage', canOpenPage)
  return canOpenPage
}
